var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.152 27.819A14.432 14.432 0 0 1 15.5 30C7.491 30 1 23.508 1 15.5S7.491 1 15.5 1c2.858 0 5.522.827 7.767 2.254",
    stroke: "#8DA5BF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.774 15.5a3.274 3.274 0 1 1-6.548 0 3.274 3.274 0 0 1 6.548 0zm9.355-7.016v8.42-8.42z",
    stroke: "#8DA5BF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.532 20.645a1.404 1.404 0 1 1-2.807 0 1.404 1.404 0 0 1 2.807 0",
    fill: "#8DA5BF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotify);
export default __webpack_public_path__ + "static/media/icon-notify.bb80d748.svg";
export { ForwardRef as ReactComponent };